import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// components
import { KanbanStageJobStatus } from "./stage.job.status";

// reducers
import { fetchOpenJobServices } from "../../stores/jobs";

// enum
import { 
  ENUM_JOB_STATUS_TECH_ASSIG,
  ENUM_JOB_STATUS_JOB_INIT,
  ENUM_JOB_STATUS_JOB_NAV_CREATED,
  ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
  ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED,
} from '../../utilities';

// kanban column
const STAGE_WAIT_TECH_ENUM = 'Finding Partner';
const STAGE_WAUT_ACTI_ENUM = 'Pending Partner Action';
const STAGE_NAV_PREMI_ENUM = 'Navigate to Premise';
const STAGE_PEND_WORK_ENUM = 'Working';
const STAGE_PEND_PAYM_ENUM = 'Pending Payment Transfer';
const STAGE_JOB_SCHED_ENUM = 'Scheduled';

export const KanbanBoardJobs = (props) => {

  // hooks
  const dispatch = useDispatch();
  const { 
    is_first_loading, 
    items = [], 
    next_token = null,
    kanban = [],
  } = useSelector((context) => context.jobs);

  // states
  const [mounted, setMounted] = useState(false);
  const [timer, setTimer] = useState(0);

  const statusToStage = (status) => {
    switch(status) {
      case ENUM_JOB_STATUS_TECH_ASSIG:                return STAGE_WAIT_TECH_ENUM;
      case ENUM_JOB_STATUS_JOB_NAV_CREATED:           return STAGE_NAV_PREMI_ENUM;
      case ENUM_JOB_STATUS_JOB_NAV_INPROGRESS:        return STAGE_NAV_PREMI_ENUM;
      case ENUM_JOB_STATUS_JOB_WORK_INPROGRESS:       return STAGE_PEND_WORK_ENUM;
      case ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING: return STAGE_PEND_PAYM_ENUM;
      default:                                        return 'NOT_INTERESTED';
    }
  }

  const loadData = async (nextToken) => {
    try {
      await dispatch(fetchOpenJobServices({
        next_token: next_token,
      })).unwrap();
    } catch (err) {
      console.error('kanban.board.jobs', 'loadData', err);
    }
  }

  useEffect(() => {
    if (!next_token) return;

    console.log('kanban.board.jobs', 'load more data');
    loadData(next_token)

  }, [next_token])

  useEffect(() => {
    // sanity check
    if (!mounted) return;
    if (!is_first_loading) return;

    console.log('kanban.board.jobs', 'load 1st data');
    dispatch(fetchOpenJobServices({
      next_token: null,
    }));

    setInterval(() => {
      console.log('timer')
      setTimer(new Date().getTime())
    }, 1000 * 60)

  }, [mounted, is_first_loading])

  useEffect(() => {
    setMounted(true); // trigger re-render when the component is mounted
  }, []) 
  
  return (
    <div className="flex flex-col space-y-4 p-0 md:flex-row md:space-x-4 md:space-y-0 md:overflow-x-auto">

      <KanbanStageJobStatus 
        key={0} 
        title={STAGE_WAIT_TECH_ENUM} 
        jobs={items.filter(item => [ENUM_JOB_STATUS_TECH_ASSIG].indexOf(item.status) > -1)} 
      />

      <KanbanStageJobStatus 
        key={1} 
        title={STAGE_WAUT_ACTI_ENUM} 
        jobs={items.filter(item => [ENUM_JOB_STATUS_JOB_INIT].indexOf(item.status) > -1)} 
      />

      <KanbanStageJobStatus 
        key={2} 
        title={STAGE_NAV_PREMI_ENUM} 
        jobs={items.filter(item => [ENUM_JOB_STATUS_JOB_NAV_CREATED, ENUM_JOB_STATUS_JOB_NAV_INPROGRESS].indexOf(item.status) > -1)} 
      />

      <KanbanStageJobStatus 
        key={3} 
        title={STAGE_PEND_WORK_ENUM} 
        jobs={items.filter(item => [ENUM_JOB_STATUS_JOB_WORK_INPROGRESS].indexOf(item.status) > -1)} 
      />

      <KanbanStageJobStatus 
        key={4} 
        title={STAGE_PEND_PAYM_ENUM} 
        jobs={items.filter(item => [ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING].indexOf(item.status) > -1)} 
      />

      {/* <KanbanStageJobStatus 
        key={5} 
        title={STAGE_JOB_SCHED_ENUM} 
        jobs={items.filter(item => [ENUM_JOB_STATUS_TECH_ASSIG].indexOf(item.status) > -1)} 
      /> */}

    </div>
  );
};
